/// <reference path="../../../../../rcwebmodels/reeferformatter.cs.d.ts" />
import * as React from 'react';
import $ from 'jquery';

import moment from 'moment';
import DateFormat from 'dateformat';
//import { DateTime } from 'react-datetime-bootstrap';
import DatePicker from 'react-datepicker';
import Formatters from '../../actions/Formatters';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import * as Highcharts from 'highcharts';
import HC_Exporting from 'highcharts/modules/exporting';
import HC_Exporting_offline from 'highcharts/modules/offline-exporting';
import forEach from 'lodash/forEach';
var Config: any = require('../../Config.json');


interface TemperatureGraphState {
    graphData: ReeferUnitHistoryUI[];
    Filters: ReeferHistoryGraphFilters;
    PreferenceDTTM: any;
    buttonState: boolean;
}

var self;
var contextMenu;

export class ReeferTemperatureGraph extends React.Component<any, TemperatureGraphState> {
    chartTemperature: Highcharts.ChartObject;
    constructor(props: any) {
        super(props);
        HC_Exporting(Highcharts);
        HC_Exporting_offline(Highcharts);
        var filterSet = this.initTemperatureGraphFilters();//new ReeferHistoryGraphFilters();
        var graphData: any = [];
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        this.state = {            
            Filters: filterSet,
            graphData: graphData,
            PreferenceDTTM: Formatters.DateTimeFormatter(currentUtcDttm),
            buttonState: false
        };
        self = this;
    }      

    initTemperatureGraphFilters() {
        var objHistoryGraphFilters = new ReeferHistoryGraphFilters();
        objHistoryGraphFilters.GrphFromDate = DateFormat(new Date(), 'mm/dd/yyyy HH:MM');
        objHistoryGraphFilters.GrphToDate = DateFormat(new Date(), 'mm/dd/yyyy HH:MM');
        objHistoryGraphFilters.Units = "";

        return objHistoryGraphFilters;
    }

    static BindTemperatureGraphData(historySearchFilters: any, graphData: any) {
        if (self != undefined && self != null) {
            var filterSet = new ReeferHistoryGraphFilters();
            filterSet.GrphFromDate = historySearchFilters.FromDate;
            filterSet.GrphToDate = historySearchFilters.ToDate;
            filterSet.Units = historySearchFilters.Units

            self.setState({
                graphData: graphData,
                Filters: filterSet
            }, () => self.initializeChart());
        }
    }

    getSeriesData(currentData: any[], seriesName: string, axesNo: number) {
        if (currentData.length > 0) {
            var returnSeriesData = [];
            $.each(currentData, function (i, val) {
                if (val.TemperatureValue != null && val.TemperatureValue != undefined) {
                    if (axesNo == 1) {                        
                        if (val.TemperatureValue != "999" && val.TemperatureValue != "-999") {
                            if (seriesName == "Humidity") {
                                if (val.TemperatureValue == "0" || val.HumiditySetPointStatus == "O")
                                    returnSeriesData.push(null);
                                else
                                    returnSeriesData.push(val.TemperatureValue);
                            }
                            else
                                returnSeriesData.push(val.TemperatureValue);
                        }
                        else {
                            returnSeriesData.push(null);
                        }
                    }
                    else {
                        var tempVal = Formatters.TemperatureFormatterForGraph(val.TemperatureValue);
                        if (tempVal != 'OOR' && tempVal != '-NA-') {
                            returnSeriesData.push(tempVal);
                        }
                        else {
                            returnSeriesData.push(null);
                        }
                    }
                }
                else {
                    returnSeriesData.push(null);
                }
            });
        }

        var TemperatureSeries;
        if (axesNo == 1) {
            TemperatureSeries = {
                name: seriesName,
                type: 'spline',
                data: returnSeriesData,
                yAxis: axesNo
            };
        }
        else {
            TemperatureSeries = {
                name: seriesName,
                type: 'spline',
                data: returnSeriesData
            };
        }

        return TemperatureSeries;
    }
   
    refreshGraphPoints() {
        //this.renderDateFields();
        //this.updateGraphData(true);
        this.BindGraphData();//RCNG-363
        this.getReeferHistoryDetails();//RCNG=430
    }
    static HighLightGraphData(selectedpoint) {
        if (self.chartTemperature != undefined && self.chartTemperature != null
            && self.chartTemperature.series != undefined && self.chartTemperature.series[0] != undefined) {
            var tempPoint = selectedpoint[0].C_EventDTTM;
            var tempDT = self.dateTimeFormatter(tempPoint);
            var seriesX = self.chartTemperature.series;
            var totalPoints = [];
            forEach(seriesX, function (values, key) {
                var allData = values.data;
                var i = 0;
                forEach(allData, function (mvalues, key) {
                    if (mvalues.category == tempDT && i==0) {
                        totalPoints.push(values.points[key]); 
                        i++;
                    }
                });

            });
            if (totalPoints.length > 0) {
                //p[0].series.name
                self.chartTemperature.tooltip.refresh(totalPoints);
            }
            //setInterval(function () {
            //    //var chart = $('#dvTemperatureGraph').highcharts();
            //    if (i < 11 && j < self.chartTemperature.series[0].data.length) {
            //        if (self.chartTemperature.series[i].data[j] != undefined && self.chartTemperature.series[i].data[j] != null) { 
            //            if (self.chartTemperature.series[i].data[j].category == te1) {
     
            //                self.chartTemperature.series[i].data[j].select(true, true);
            //                v.push(self.chartTemperature.series[i].data[j]);
            //                //self.chartTemperature.tooltip.refresh(self.chartTemperature.series[i].data[j]);
            //            //self.chartTemperature.series[i].data[j].category;
            //            }
            //            if (++j == self.chartTemperature.series[0].data.length) {
            //            i++;
            //            j = 0;
            //        }
            //    }
            //    }
                
            //}, 1);
            //if (v.length > 0) {
            //    //self.chartTemperature.tooltip.refresh(v);
            //}
        }
    }
    static ClearGraphData() {
        if (self != undefined) {
            self.setState({
                graphData: [],
            }, () => self.updateGraphData(false));
            $("#dvTemperatureGraph").hide();
            self.enableDisableSearchButton(false);
            self.renderDateFields();
        }
    }

    updateGraphData(loader:any) {
        if (this.chartTemperature != undefined && this.chartTemperature != null
            && this.chartTemperature.series != undefined && this.chartTemperature.series[0] != undefined) {
            if (this.state.graphData.length > 0) {
                var graphCurrentData = this.GraphPoints();
                this.chartTemperature.xAxis[0].removePlotBand('temperatureGraphPlot2');
                if (graphCurrentData.xAxisPlotData != null && graphCurrentData.xAxisPlotData.length > 0) {
                   // this.chartTemperature.xAxis[0].removePlotBand('temperatureGraphPlot2');
                    $.each(graphCurrentData.xAxisPlotData, function (i, val) {
                        self.chartTemperature.xAxis[0].addPlotBand(val);
                    });
                }

                this.chartTemperature.xAxis[0].setCategories(graphCurrentData.xAxisData);
                this.chartTemperature.series[0].setData(graphCurrentData.yAxisData[0].data);
                this.chartTemperature.series[1].setData(graphCurrentData.yAxisData[1].data);
                this.chartTemperature.series[2].setData(graphCurrentData.yAxisData[2].data);
                this.chartTemperature.series[3].setData(graphCurrentData.yAxisData[3].data);
                this.chartTemperature.series[4].setData(graphCurrentData.yAxisData[4].data);
                this.chartTemperature.series[5].setData(graphCurrentData.yAxisData[5].data);
                this.chartTemperature.series[6].setData(graphCurrentData.yAxisData[6].data);
                this.chartTemperature.series[7].setData(graphCurrentData.yAxisData[7].data);
                this.chartTemperature.series[8].setData(graphCurrentData.yAxisData[8].data);
                this.chartTemperature.series[9].setData(graphCurrentData.yAxisData[9].data);
                this.chartTemperature.series[10].setData(graphCurrentData.yAxisData[10].data);
                this.chartTemperature.redraw();                
                $('.highcharts-reset-zoom').click();
                if (graphCurrentData.yAxisData[0].data.length == 0 && graphCurrentData.yAxisData[1].data.length == 0
                    && graphCurrentData.yAxisData[2].data.length == 0 && graphCurrentData.yAxisData[3].data.length == 0
                    && graphCurrentData.yAxisData[4].data.length == 0 && graphCurrentData.yAxisData[5].data.length == 0
                    && graphCurrentData.yAxisData[5].data.length == 0 && graphCurrentData.yAxisData[6].data.length == 0
                    && graphCurrentData.yAxisData[7].data.length == 0 && graphCurrentData.yAxisData[8].data.length == 0
                    && graphCurrentData.yAxisData[9].data.length == 0 && graphCurrentData.yAxisData[10].data.length == 0) {
                    $('#dvGraphMsgBox').show();
                }
                else {
                    $('#dvGraphMsgBox').hide();
                }
            }
            else {
                this.chartTemperature.xAxis[0].setCategories([]);
                this.chartTemperature.series[0].setData([]);
                this.chartTemperature.series[1].setData([]);
                this.chartTemperature.series[2].setData([]);
                this.chartTemperature.series[3].setData([]);
                this.chartTemperature.series[4].setData([]);
                this.chartTemperature.series[5].setData([]);
                this.chartTemperature.series[6].setData([]);
                this.chartTemperature.series[7].setData([]);
                this.chartTemperature.series[8].setData([]);
                this.chartTemperature.series[9].setData([]);
                this.chartTemperature.series[10].setData([]);
                this.chartTemperature.redraw();
                $('#dvGraphMsgBox').show();
                $('.highcharts-reset-zoom').click();
            }
        }
        if (loader)
            $('#globalLoader').hide();
    }

    GraphPoints() {
        var returnTemperatures = [];
        var setPointTemperatures = [];
        var supplyTemperatures = [];
        var usda1Temperatures = [];
        var usda2Temperatures = [];
        var usda3Temperatures = [];
        var cargo4Temperatures = [];
        var ambientTemperatures = [];
        var humidityTemperatures = [];
        var o2Temperatures = [];
        var co2Temperatures = [];
        var reeferIdSelected = this.state.graphData[0].ReeferID;
        var graphTimes = this.state.graphData.map(x => x.EventDTTM);
        var xAxisCategories = [];
        var xAxisPlotValues = [];
        var RunStateValues = [];

        RunStateValues = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            RCDPowerSourceCd: x.RCDPowerSourceCd
        }));
        RunStateValues = RunStateValues.sort(x => x.EventDTTM).reverse();

        // declare some variables prepare plot bands 
        var plotBandsArray: any[] = [];
        try {
            var a = 0;
            var m = 0;
            var n = 0;
            var e = 0;
            var f = 0;
            var allBat = 0;
            var max = RunStateValues.length - 1;
            // prepare a plotband array like [start position of RCDPowerSourceCd=B(index),end position of RCDPowerSourceCd=B(index)] like [[2,6],[11,14],[18,20]]
            for (var i = a; i < RunStateValues.length; i++) {
                if (RunStateValues[i].RCDPowerSourceCd == 'B') {
                    m = i;
                    for (var j = i; j < RunStateValues.length; j++) {
                        if (RunStateValues[j].RCDPowerSourceCd == 'A') {
                            n = j;
                            i = j;
                            plotBandsArray.push([m, n])
                            break;
                        }
                    }

                }
            }
            // find B exists before A occurs from last
            for (var g = max; g >= 0; g--) {
                if (RunStateValues[g].RCDPowerSourceCd == 'B') {
                    e = g;
                    break;
                }

            }
             // find A exists before B occurs from last and find there is NO A exists
            for (var h = max; h >= 0; h--) {
                if (RunStateValues[h].RCDPowerSourceCd == 'A') {
                    f = h;
                    allBat = 1;
                    break;
                }

            }
            //if B exists before A means last point will be [Bindex,last point of array] 
            // if all battery total graph ploted with band
            if (e > f) {
                if (e != RunStateValues.length) {
                    if (allBat == 1) {
                        plotBandsArray.push([f + 1, max])
                    } else {
                        plotBandsArray.push([f , max])
                    }
                }
            }

            var i = 0;
            while (i < plotBandsArray.length) {
                var plotBandObject = {
                    color: '#ececeb',
                    from: plotBandsArray[i][0],
                    to: plotBandsArray[i][1],
                    id: 'temperatureGraphPlot2',
                    label: {
                        text: 'Battery power',
                        y:50,
                        rotation: 90,
                        align: 'center'
                    }
                };
                xAxisPlotValues.push(plotBandObject);
                i += 1;
            }
        } catch (Error) {

            // ignore errors during prepare a plotband array 
            //PopupWindow.showErrorMessage("Alert", Error.message);

        }

        $.each(graphTimes, function (i, val) {            
            xAxisCategories.push(self.dateTimeFormatter(val));
        });

        xAxisCategories.sort();

        // Y1-axis Data
        returnTemperatures = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            TemperatureValue: x.ReturnTemp1
        }));        
        returnTemperatures = returnTemperatures.sort(x => x.EventDTTM).reverse();
        var returnTemperaturesSeries = this.getSeriesData(returnTemperatures, 'Return', 2);
        returnTemperaturesSeries.color = "#EC7063";        

        setPointTemperatures = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            TemperatureValue: x.SetPoint
        }));
        setPointTemperatures = setPointTemperatures.sort(x => x.EventDTTM).reverse();
        var setPointTemperaturesSeries = this.getSeriesData(setPointTemperatures, 'Setpoint', 2);
        setPointTemperaturesSeries.color = "#F1C40F";
       
        supplyTemperatures = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            TemperatureValue: x.SupplyTemp1
        }));
        supplyTemperatures = supplyTemperatures.sort(x => x.EventDTTM).reverse();
        var supplyTemperaturesSeries = this.getSeriesData(supplyTemperatures, 'Supply', 2);
        supplyTemperaturesSeries.color = "#27AE60";

        usda1Temperatures = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            TemperatureValue: x.USDA1Temp
        }));
        usda1Temperatures = usda1Temperatures.sort(x => x.EventDTTM).reverse();
        var usda1TemperaturesSeries = this.getSeriesData(usda1Temperatures, 'USDA1', 2);
        usda1TemperaturesSeries.color = "#0E6655";

        usda2Temperatures = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            TemperatureValue: x.USDA2Temp
        }));
        usda2Temperatures = usda2Temperatures.sort(x => x.EventDTTM).reverse();
        var usda2TemperaturesSeries = this.getSeriesData(usda2Temperatures, 'USDA2', 2);
        usda2TemperaturesSeries.color = "#A04000";

        usda3Temperatures = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            TemperatureValue: x.USDA3Temp
        }));
        usda3Temperatures = usda3Temperatures.sort(x => x.EventDTTM).reverse();
        var usda3TemperaturesSeries = this.getSeriesData(usda3Temperatures, 'USDA3', 2);
        usda3TemperaturesSeries.color = "#95A5A6";

        cargo4Temperatures = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            TemperatureValue: x.Cargo4Temp
        }));
        cargo4Temperatures = cargo4Temperatures.sort(x => x.EventDTTM).reverse();
        var cargo4TemperaturesSeries = this.getSeriesData(cargo4Temperatures, 'USDA4', 2);
        cargo4TemperaturesSeries.color = "#FF5722";

        ambientTemperatures = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            TemperatureValue: x.AmbientTemp
        }));
        ambientTemperatures = ambientTemperatures.sort(x => x.EventDTTM).reverse();
        var ambientTemperaturesSeries = this.getSeriesData(ambientTemperatures, 'Ambient', 2);
        ambientTemperaturesSeries.color = "#9CCC65";

        // Y2-axis Data
        humidityTemperatures = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            TemperatureValue: x.Humidity,
            HumiditySetPointStatus: x.HumiditySetpointStatus
        }));
        humidityTemperatures = humidityTemperatures.sort(x => x.EventDTTM).reverse();
        var humidityTemperaturesSeries = this.getSeriesData(humidityTemperatures, 'Humidity', 1);
        humidityTemperaturesSeries.color = "#800080";

        o2Temperatures = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            TemperatureValue: x.O2Reading
        }));
        o2Temperatures = o2Temperatures.sort(x => x.EventDTTM).reverse();
        var o2TemperaturesSeries = this.getSeriesData(o2Temperatures, 'O2', 1);
        o2TemperaturesSeries.color = "#F57F17";

        co2Temperatures = this.state.graphData.map(x => ({
            EventDTTM: x.EventDTTM,
            TemperatureValue: x.CO2Reading
        }));
        co2Temperatures = co2Temperatures.sort(x => x.EventDTTM).reverse();
        var co2TemperaturesSeries = this.getSeriesData(co2Temperatures, 'CO2', 1);
        co2TemperaturesSeries.color = "#FDD835";

        var dataObject = {
            reeferId: reeferIdSelected,            
            xAxisData: xAxisCategories,
            xAxisPlotData: xAxisPlotValues,
            yAxisData: [setPointTemperaturesSeries, returnTemperaturesSeries, supplyTemperaturesSeries, usda1TemperaturesSeries, usda2TemperaturesSeries, usda3TemperaturesSeries, cargo4TemperaturesSeries, ambientTemperaturesSeries, humidityTemperaturesSeries, o2TemperaturesSeries, co2TemperaturesSeries]
        }

        return dataObject;
    }
    
    BindGraphData() {
        if (this.state.graphData != null && this.state.graphData.length > 0) {
            var parent = this;
            var element = document.getElementById('dvTemperatureGraph');

            var tooltipOption: Highcharts.TooltipOptions = {
                shared: true,
                useHTML: true,
                headerFormat: '<small>{point.key:%m-%d-%y %H:%M}</small><table>',
                pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
                    '<td style="text-align: right"><b>{point.y}</b></td></tr>',
                footerFormat: '</table>',
            }
            var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
            //var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
            
            if (typeof (element) != 'undefined' && element != null) {
                //if (isChrome) {
                //    if (!contextMenu) {
                //        Highcharts.setOptions({
                //            global: {
                //                useUTC: false
                //            },
                //            exporting: {
                //                buttons: {
                //                    contextButton: {
                //                        //menuItems: Highcharts.getOptions().exporting.buttons.contextButton.menuItems.splice(2)
                //                        menuItems: ['downloadPNG', 'downloadJPEG']
                //                    }
                //                }
                //            }
                //        });
                //    }
                //}
                //else {
                    Highcharts.setOptions({
                        global: {
                            useUTC: false
                        },
                        exporting: {
                            buttons: {
                                contextButton: {
                                    menuItems: ['downloadPNG', 'downloadJPEG']//26022 'printChart', 'separator', 
                                }
                            }
                        }
                    });
                //}

                var graphCurrentData = this.GraphPoints();
                if (graphCurrentData.yAxisData[0].data.length == 0 && graphCurrentData.yAxisData[1].data.length == 0
                    && graphCurrentData.yAxisData[2].data.length == 0 && graphCurrentData.yAxisData[3].data.length == 0
                    && graphCurrentData.yAxisData[4].data.length == 0 && graphCurrentData.yAxisData[5].data.length == 0
                    && graphCurrentData.yAxisData[5].data.length == 0 && graphCurrentData.yAxisData[6].data.length == 0
                    && graphCurrentData.yAxisData[7].data.length == 0 && graphCurrentData.yAxisData[8].data.length == 0
                    && graphCurrentData.yAxisData[9].data.length == 0 && graphCurrentData.yAxisData[10].data.length == 0) {
                    $('#dvGraphMsgBox').show();
                }
                else {
                    $('#dvGraphMsgBox').hide();
                }

                parent.chartTemperature = Highcharts.chart('dvTemperatureGraph', {
                    chart: {
                        zoomType: 'xy'
                    },
                    title: {
                        text: 'Reefer Monitoring Data: ' + graphCurrentData.reeferId.slice(0, 4).concat(' ').concat(graphCurrentData.reeferId.slice(4, 10)).concat(' ').concat(graphCurrentData.reeferId.slice(10, 11))
                        //text: ''
                    },
                    xAxis: [{
                        type: 'dateTime',
                        categories: graphCurrentData.xAxisData,
                        labels: {
                            format: '{value:%m-%d-%y %H:%M}'
                        },
                        plotBands: graphCurrentData.xAxisPlotData
                    }],
                    exporting: {
                        enabled: true,
                        sourceWidth: 1600,
                        sourceHeight: 500,
                        chartOptions: {
                            plotOptions: {
                                series: {
                                    dataLabels: {
                                        enabled: true
                                    }
                                }
                            }
                        }
                    },
                    yAxis: [{ // Primary yAxis
                        labels: {
                            //format: '{value}°C',  
                            formatter: function () {
                                return this.value + '°' + tempUnitCd.toUpperCase();
                            },
                            style: {
                                color: "#388E3C"
                            }
                        },
                        title: {
                            text: 'Temperature',
                            style: {
                                color: "#388E3C"
                            }
                        }
                    }, { // Secondary yAxis
                        gridLineWidth: 0,
                        title: {
                            text: 'Percentage',
                            style: {
                                color: Highcharts.getOptions().colors[0]
                            }
                        },
                        labels: {
                            format: '{value} %',
                            style: {
                                color: Highcharts.getOptions().colors[0]
                            }
                        },
                        opposite: true
                    }],
                    plotOptions: {
                        spline: {
                            marker: {
                                enabled: true
                            }
                        },
                        series: {
                            connectNulls: true
                        }
                    },
                    tooltip: tooltipOption,
                    legend: {
                        layout: 'vertical',
                        align: 'right',
                        verticalAlign: 'middle',
                        floating: false,
                        backgroundColor: 'rgba(255,255,255,0.25)'
                    },
                    series: graphCurrentData.yAxisData
                });

                contextMenu = true;
            }
        }        
    }

    componentDidMount() {
        this.renderDateFields();
        this.enableDisableSearchButton(false);
        //this.BindGraphData();
        contextMenu = false;        
    }

    renderDateFields() {
        var currentDateFilters = this.state.Filters;

        if (this.state.graphData != null && this.state.graphData != undefined && this.state.graphData.length > 0) {
            var graphTimes: any[] = this.state.graphData.map(x => new Date(x.EventDTTM));
            var graphSortedTimes = graphTimes.sort(function (a, b) { return b.getTime() - a.getTime() });
            var toDTTM = Formatters.DateTimeFormatter(graphSortedTimes[0]);
            var fromDTTM = Formatters.DateTimeFormatter(graphSortedTimes[graphSortedTimes.length - 1]);
            var toDate = moment(new Date(toDTTM)).endOf('day').toString();
            var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            currentDateFilters.GrphFromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            currentDateFilters.GrphToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');            
            this.setState({ Filters: currentDateFilters });
        }
        else {
            var toDTTM = DateFormat(new Date(Date.now()), 'mm/dd/yyyy');
            var modifiedDttm = new Date(Date.now());
            modifiedDttm.setDate(modifiedDttm.getDate() - 1);
            var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');
            var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            var toDate = moment(new Date(toDTTM)).endOf('day').toString();
            currentDateFilters.GrphFromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            currentDateFilters.GrphToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            this.setState({ Filters: currentDateFilters });
        }
    }

    initializeChart() {
        //this.renderDateFields();
        this.enableDisableSearchButton(true);
        $("#dvTemperatureGraph").show();
        //if (this.chartTemperature != undefined && this.chartTemperature != null)
        //    this.updateGraphData(false);
        //else        
        this.BindGraphData();
    }

    fromDateChange(date) {
        var filters = self.state.Filters;
        filters.GrphFromDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({ Filters: filters });
        //$('#btnReeferHistorySearch').removeAttr('disabled');
    }

    toDateChange(date) {
        var filters = self.state.Filters;
        filters.GrphToDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({ Filters: filters });
    }

    enableDisableSearchButton(isEnable: any) {
        if (isEnable) {
            this.setState({ buttonState: true });
        }
        else {
            this.setState({ buttonState: false });
        }
    }

    ValidateHistoryDates(filters: any) {
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        var currentDttm = Formatters.DateTimeFormatter(currentUtcDttm);
        this.setState({ PreferenceDTTM: currentDttm });
        //var currentDttm = this.state.PreferenceDTTM;
        var fromDttm = filters.GrphFromDate;
        var toDttm = filters.GrphToDate;
        if (fromDttm == "Invalid date" || fromDttm == null || fromDttm == "")
            return "Invalid From Date.";

        if (toDttm == "Invalid date" || toDttm == null || toDttm == "")
            return "Invalid To Date.";

        if (moment(new Date(fromDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "From date should not be greater than current date.";

        if (moment(new Date(toDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "To date should not be greater than current date.";

        if (moment(new Date(fromDttm)) > moment(new Date(toDttm)))
            return "From Date should not be greater than To Date.";

        return "";
    }

    getReeferHistoryDetails() {
        $('#globalLoader').show();
        var filters = this.state.Filters;
        var message = this.ValidateHistoryDates(filters);
        if (message != "") {
            PopupWindow.showErrorMessage("Alert", message);
            $('#globalLoader').hide();
            return;
        }
        else {
            this.setState({ Filters: filters });
        }
        var fromDate = moment(new Date(filters.GrphFromDate)).toString();
        var toDate = moment(new Date(filters.GrphToDate)).toString();
        //filters.FromDate = filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        //filters.ToDate = filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        var historyParams = { FromDate: DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM'), ToDate: DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM'), Units: filters.Units };
        var filterParams = JSON.stringify(historyParams);

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferhistory/ReeferHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<ReeferUnitHistoryUI[]>)
            .then(data => {
                this.setState({
                    graphData: data
                }, () => this.updateGraphData(true));
            });
    }

    dateTimeFormatter(dateTimeVal: any) {
        if (dateTimeVal != null && dateTimeVal != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(dateTimeVal.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return prefDateTime.getTime();
        }
        else {
            return null;
        }
    }

    public render() {
        return <div>
            <div className='ReeferMonitoringSearch'>

            <div className='aggrid-icons-bg TempRefresh'>
                <div className="btn-group aggrid-icons">
                        <button type="button" id="hidePopUpBtnRefresh" title='Refresh' className="btn btn-outline-secondary" onClick={this.refreshGraphPoints.bind(this)} ><span className='fas fa-sync-alt'></span></button>
                    </div></div>

                <div className="widget-calender">

                    <div className="input-group from-to-calender">
                        <span className="input-group-text">From</span>
                        <DatePicker
                            selected={new Date(this.state.Filters.GrphFromDate)}
                            maxDate={new Date(this.state.PreferenceDTTM)}
                            onChange={this.fromDateChange.bind(this)}
                            timeInputLabel="Time:"
                            showYearDropdown
                            yearDropdownItemNumber={5}
                            dateFormat="MM/dd/yyyy hh:mm aa"
                            showTimeInput  
                            className=""                          
                        />
                        <span className="input-group-text">To</span>
                        <DatePicker
                            selected={new Date(this.state.Filters.GrphToDate)}
                            maxDate={new Date(this.state.PreferenceDTTM)}
                            onChange={this.toDateChange.bind(this)}
                            timeInputLabel="Time:"
                            showYearDropdown
                            yearDropdownItemNumber={5}
                            dateFormat="MM/dd/yyyy hh:mm aa"
                            showTimeInput  
                            className=""                          
                        />                        

                        {
                            this.state.buttonState == true ?
                                <button type='button' onClick={this.getReeferHistoryDetails.bind(this)} className='btn btn-primary float-start'>Search</button>
                                :
                                <button type='button' disabled={this.state.buttonState == false} className='btn btn-primary float-start'>Search</button>
                        }

                    </div>

                </div>

             </div>
            <div id="dvGraphMsgBox" className='alert-temp'>No Data Available</div>
            <div id="dvTemperatureGraph"></div>
        </div>
    }
}

class ReeferHistoryGraphFilters {
    GrphFromDate: string;
    GrphToDate: string;
    Units: string;
}

interface ReeferUnitHistoryUI {
    HighSpeedEvaporatorFanOutPut: string;
    IsAcceptableBatteryVoltage?: boolean;
    BatteryVoltage?: number;
    RCDPowerSourceCd: string;
    ReeferACPowerLevel?: number;
    ReeferOEMTypeCd: string;
    IsReeferPhysicallyConnected?: boolean;
    IsReeferCommunicationEstablished?: boolean;
    ReeferSwitchOn?: boolean;
    DeviceTemp?: number;
    UnitEventID?: number;
    EventMasterID?: number;
    EventDTTM?: Date;
    ModifiedDTTM?: Date;
    U_UnitAlarmSummaryHistoryID?: number;
    UnitControlEventID?: number;
    C_EventDTTM?: Date;
    C_EventMasterID?: number;
    UnitVesselOperationsID?: number;
    UnitCargoCareID?: number;
    C_UnitAlarmSummaryHistoryID?: number;
    Status: string;
    IsOnVessel: boolean;
    IsCargoCare: boolean;
    IsAcceptableACVoltage?: boolean;
    R_RCDStateReportedHistoryID?: number;
    RunState?: number;
    ControlledAtmosphereMode: string;
    R_EventDTTM?: Date;
    TimeToDefrost?: number;
    LineFrequency?: number;
    CurrentPhaseA?: number;
    CurrentPhaseB?: number;
    CurrentPhaseC?: number;
    ThreePhaseCurrent: string;
    ReturnTempLongAvg?: number;
    AmbientTempLongAvg?: number;
    CompositeSuctionPressureLongAvg?: number;
    DischargePressureLongAvg?: number;
    SupplyTemperatureLongAvg?: number;
    ReturnTemperatureLongAvg?: number;
    CompressorSuctionTempLongAvg?: number;
    CompressorCondensorTempLongAvg?: number;
    RCDEventID?: number;
    R_EventMasterID?: number;
    RCDMasterID?: number;
    RCDMasterHistoryID?: number;
    RCDGSMPositionHistoryID?: number;
    RCDLocationHistoryID?: number;
    RCDGPSPositionHistoryID?: number;
    RCDStateReportedHistoryID?: number;
    RCDAlarmSummaryHistoryID?: number;
    CCIsOffpower?: boolean;
    CCIsSetpoint?: boolean;
    CCMissingScheduleCd?: number;
    CCIsTempOutOfRange?: boolean;
    SIM_IMSI: string;
    ICCID: string;
    CompressorEvaporatorTempLongAvg?: number;
    CompressorDischargeTempLongAvg?: number;
    CountryCd: string;
    CountryName: string;
    UnitEventDTTM?: Date;
    UnitMasterID?: number;
    RCDReportingInterval?: number;
    Street: string;
    City: string;
    State: string;
    Zip: string;
    RCDRfrComErr?: boolean;
    TripId?: number;
    TripNm: string;
    TripStatusCd: string;
    TripStatusDescription: string;
    TripNameAndStatus: string;
    TripHistoryId?: number;
    BookedTemperature?: number;
    BookingNumber: string;
    TemperatureUnit: string;
    MSISDN: string;
    DataLoggerDtm?: Date;
    RSSI?: number;
    HotGasValveOpening?: number;
    C_ModifiedDTTM?: Date;
    GeofenceName: string;
    RCDID: string;
    Country: string;
    RCDFirmwareVersion: string;
    RCDBootloaderVersion: string;
    RCDMeshFirmwareVersion: string;
    RevisionNum?: number;
    LineVoltage1?: number;
    LineVoltage2?: number;
    LineVoltage3?: number;
    GPSLatitude?: number;
    GPSLongitude?: number;
    GPSLastLock?: number;
    GPSCoords: string;
    GPSLockState: string;
    IsInsideGeofence?: boolean;
    Geofence: string;
    CustomerAccessGroupIDList: string;
    TowerBaseStationID?: number;
    TowerLocalizationAreaCode?: number;
    MNC?: number;
    SuctionModulationValveOpening?: number;
    EconomizerValveOpening?: number;
    CondenserFanOutPut: string;
    DeviationFlg?: boolean;
    LowSpeedEvaporatorFanOutPut: string;
    CompositeSuctionPressureQualifier?: any;
    PretripTestStateID?: any;
    DefrostInterval: string;
    VentPositionCMHQualifier?: any;
    TotalCurrentDrawQualifier?: any;
    PretripTimeDisplay: string;
    PretripTestNumber?: number;
    PretripSubTestNumber?: number;
    SetPoint?: number;
    O2Setpoint?: number;
    CO2Setpoint?: number;
    HumiditySetpoint?: number;
    CompressorHighSpeed?: number;
    ElectricHeatOutPut?: number;
    MicroVersion: string;
    SoftwareRevision: string;
    AmbientTempQualifier?: any;
    USSH_Cargo4TempQualifier?: any;
    CO2ReadingQualifier?: any;
    CO2SetpointQualifier?: any;
    ColdTreatmentActive?: boolean;
    CompressorDischargeTempQualifier?: any;
    CompressorSuctionTempQualifier?: any;
    DischargePressureQualifier?: any;
    CondenserFanOutputQualifier?: any;
    HumiditySetpointStatus: string;
    O2ReadingSupport: string;
    ParentEventID?: number;
    UnitPrefix: string;
    UnitNumber: string;
    ReeferID: string;
    AlarmsList: string;
    CCAlarms: string;
    CCSeverityLevel: string;
    MicroAlarms: string;
    MASeverityLevel: string;
    UnitUSDAHistoryID?: number;
    USDA1Temp?: number;
    USDA1TempQualifier?: any;
    USDA2Temp?: number;
    USDA2TempQualifier?: any;
    USDA3Temp?: number;
    USDA3TempQualifier?: any;
    Cargo4Temp?: number;
    Cargo4TempQualifier?: any;
    UnitSettingsHistoryID?: number;
    DischargePressure?: number;
    CompositeSuctionPressure?: number;
    VentPositionSensorCMH?: number;
    O2SetpointSupport: string;
    CO2ReadingSupport: string;
    CondenserPressureQualifier?: any;
    DataLoggerDtmQualifier?: any;
    CurrentPhaseCQualifier?: any;
    ControllerSerialNumber: string;
    CompressorFrequency?: number;
    CondenserTemperature?: number;
    CondenserPressure?: number;
    HeaterOnTime?: number;
    EvaporatorExpansionValveOpening?: number;
    RunningMode: string;
    URH_UnitReadingsHistoryID?: number;
    Humidity?: number;
    AmbientTemp?: number;
    CompressorSuctionTemp?: number;
    CompressorDischargeTemp?: number;
    ReturnTemp1?: number;
    SupplyTemp1?: number;
    SupplyTemp2?: number;
    ReturnTemp2?: number;
    EvaporatorTemp?: number;
    NumberOfAlarmsInQue?: number;
    O2Reading?: number;
    CO2Reading?: number;
    OEMAlarmBlock: string;
    ISOFaultBlock: string;
    TotalCurrentDraw?: number;
    SupplyTempQualifier?: any;
    SupplyTemp3Qualifier?: any;
    SupplyTemp2Qualifier?: any;
    SupplyTemp1Qualifier?: any;
    CondenserTempQualifier?: any;
    ControllerSerialNumberQualifier?: any;
    CurrentPhaseAQualifier?: any;
    CurrentPhaseBQualifier?: any;
    DefrostIntervalQualifier?: any;
    EconomizerValveOpeningQualifier?: any;
    EvaporatorExpansionValveOpeningQualifier?: any;
    EvaporatorTempQualifier?: any;
    UnitHardwareVersion: string;
    HeaterOnTimeQualifier?: any;
    HighSpeedEvaporatorFanOutputQualifier?: any;
    TripStatusCdAndDFlag: string;
    HotGasValveOpeningQualifier?: any;
    LowSpeedEvaporatorFanOutputQualifier?: any;
    MicroVersionQualifier?: any;
    O2ReadingQualifier?: any;
    O2SetpointQualifier?: any;
    PowerSupplyDCVoltageQualifier?: any;
    ReturnTemp1Qualifier?: any;
    ReturnTemp2Qualifier?: any;
    ReturnTemp3Qualifier?: any;
    ReturnTempQualifier?: any;
    SetPointQualifier?: any;
    SuctionModulationValveOpeningQualifier?: any;
    LineFrequencyQualifier?: any;
}